import Component from "../../classes/Component";

const filterAdaptiveSelector = '.js-filter-remove-adaptive'

export default function () {

    return new Component({
        name: 'filterAdaptive',
        requiredTargets: [filterAdaptiveSelector],
        onInit() {

        },
        onDestroy() {
            console.log('filterAdaptive')
        },
    })

}